import { http } from "@/utils/request";
import type { UsersResponse } from "@/types/user.types";

// 后端字段说明：
// end_blue_score - 结束蓝思值
// end_invitation_cnt - 最大邀请人数
// end_level - 最大等级
// invitation_code - 邀请码
// invitation_end_end_time - 会员结束时间
// invitation_end_start_time - 会员开始时间
// member_status - 会员状态（-1：不限，0：否，1：是）
// nick_name - 昵称
// page - 页数
// phone - 手机号
// reg_end_time - 注册结束时间
// reg_start_time - 注册开始时间
// page_size - 每页大小
// start_blue_score - 开始蓝思值
// start_invitation_cnt - 最小邀请人数
// start_level - 最小等级
// user_id - 用户id
export type GetUsersParams = {
  page: number;
  size: number;

  // 条件查询四选一：user_id | nick_name | phone | invitation_code
  user_id?: string | number;
  nick_name?: string;
  phone?: string;
  invitation_code?: string;

  // 时间筛选：注册时间 或 会员到期时间（二者可分别传）
  reg_start_time?: string; // YYYY-MM-DD
  reg_end_time?: string;
  invitation_end_start_time?: string; // 会员开始时间（到期时间范围的开始）
  invitation_end_end_time?: string; // 会员结束时间（到期时间范围的结束）

  // 等级范围
  start_level?: number;
  end_level?: number;

  // 会员状态：-1 不限；0 否；1 是
  member_status?: -1 | 0 | 1;

  // 蓝思值范围
  start_blue_score?: number;
  end_blue_score?: number;

  // 邀请人数范围
  start_invitation_cnt?: number;
  end_invitation_cnt?: number;
};

export const userService = {
  // 获取用户列表
  getUsers: async (params: GetUsersParams): Promise<UsersResponse> => {
    return http.get<UsersResponse>("/user/list", params);
  },

  // 修改会员时间
  updateUserMembership: async (userId: string, date: string): Promise<any> => {
    return http.put<any>("/user/member", {
      id: userId,
      date: date,
    });
  },

  // 修改手机号 /user/phone
  updateUserPhone: async (
    userId: string,
    newPhoneNumber: string
  ): Promise<any> => {
    return http.put<any>("/user/phone", {
      id: userId,
      phone: newPhoneNumber,
    });
  },
};
